import { PartnerTypeLabel } from 'vopay';

export type ProgramTermsVariant = 'revShare' | 'minimumProgramFee';

/**
 * Which program term the partner's agreement carries, by partner type (spec 5.2.1). Referral ISO,
 * Referral ISV and Inside Sales have neither, so the card is hidden for them — as it is for an
 * unknown or not-yet-loaded partner type.
 */
export default function getProgramTermsVariant(partnerTypeLabel: PartnerTypeLabel): ProgramTermsVariant | null {
  switch (partnerTypeLabel) {
    case 'Referral - ISV RevShare':
      return 'revShare';
    case 'VAR - PaaS':
    case 'VAR - PayFac (Non-Reporting)':
    case 'VAR - PayFac (Reporting)':
    case 'Technology Partner':
      return 'minimumProgramFee';
    default:
      return null;
  }
}
